import { getPublicProductPath } from "utils";

import { env } from "src/env";

export function getPublicProductUrl(
  coachSlug: string,
  productSlug: string,
): string {
  return `${env.VITE_APP_WEB_ORIGIN}${getPublicProductPath(coachSlug, productSlug)}`;
}
